import { processNodeAndPermissions } from "../../../helper/com-helper";
import { Snop } from "../../../assets/svg-icons";
import { OM } from "./OM";

const IEO_OBJECT = {
  name: "Intelligent Execution Orchestration",
  route: "/ieo/sales-order",
  permissions: [],
  child: {
    "Order Management": OM,
    // "iTMS": {
    //   name: "iTMS",
    //   shortName: "iTMS",
    //   route: null,
    //   permissions: [],
    //   icon: Snop,
    //   child: {
    //     "STO-Sales Orders": {
    //       name: "STO-Sales Orders",
    //       route: "/tms/sto-salesorders",
    //       permissions: ["SNOE_VIEW"],
    //       icon: Snop,
    //     },
    //   },
    // },
  }
};

processNodeAndPermissions(IEO_OBJECT);
export const IEO = IEO_OBJECT;
